import { useCallback, useState } from 'react';
// TODO: tests
export function useRequestLoading() {
  const [isLoading, setIsLoading] = useState();

  const callbackRequest = useCallback(async cb => {
    try {
      setIsLoading(true);
      await cb();
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  }, []);
  return { requestLoading: isLoading, callbackRequest };
}
